/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} L6_Cta_H2Inputs */

const es_l6_cta_h2 = /** @type {(inputs: L6_Cta_H2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cobra menos comisión. Llena más semanas.`)
};

const gl_l6_cta_h2 = /** @type {(inputs: L6_Cta_H2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cobra menos comisión. Enche máis semanas.`)
};

const en_l6_cta_h2 = /** @type {(inputs: L6_Cta_H2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pay less commission. Fill more weeks.`)
};

/**
* | output |
* | --- |
* | "Pay less commission. Fill more weeks." |
*
* @param {L6_Cta_H2Inputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const l6_cta_h2 = /** @type {((inputs?: L6_Cta_H2Inputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<L6_Cta_H2Inputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_l6_cta_h2(inputs)
	if (locale === "en") return en_l6_cta_h2(inputs)
	return es_l6_cta_h2(inputs)
});